<template>
  <div v-if="!requiredIf && show">
    <CBadge class="ma-2" color="danger"  x-small label>必須</CBadge>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    requiredIf: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style module lang="scss"></style>
